import React, { useEffect, useState } from 'react';
import Photo from './Photo';
import { capSizes } from '../utils/pbImageUrl';

const WIDE = '(min-width: 1024px)';

function useColumnCount() {
  const [wide, setWide] = useState(() => window.matchMedia(WIDE).matches);
  useEffect(() => {
    const query = window.matchMedia(WIDE);
    const onChange = (e) => setWide(e.matches);
    query.addEventListener('change', onChange);
    return () => query.removeEventListener('change', onChange);
  }, []);
  return wide ? 3 : 2;
}

// Photos visible before scrolling on a phone; these load first, the rest lazily.
const ABOVE_THE_FOLD = 4;

/**
 * Masonry grid that keeps each photo's own proportions: 2 columns on phones,
 * 3 on large screens. Photos are dealt left to right so the order reads in rows.
 */
function PhotoGrid({ images, alt, onOpen }) {
  const columnCount = useColumnCount();
  const columns = Array.from({ length: columnCount }, () => []);
  images.forEach((image, index) => columns[index % columnCount].push({ image, index }));

  return (
    <div className="flex items-start gap-2 sm:gap-3">
      {columns.map((column, c) => (
        <div key={c} className="flex min-w-0 flex-1 flex-col gap-2 sm:gap-3">
          {column.map(({ image, index }) => (
            <button
              key={image.id}
              type="button"
              onClick={() => onOpen(index)}
              className="reveal block w-full overflow-hidden rounded-md bg-base-200 transition-transform duration-200 active:scale-[0.98] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              aria-label={`Open photo ${index + 1} of ${images.length}`}
            >
              <Photo
                src={image.url}
                srcSet={image.srcSet}
                sizes={capSizes('(min-width: 1152px) 380px, (min-width: 1024px) 33vw, 50vw')}
                alt={image.title || alt}
                priority={index < ABOVE_THE_FOLD}
              />
            </button>
          ))}
        </div>
      ))}
    </div>
  );
}

export default PhotoGrid;
